// extracted by mini-css-extract-plugin
var _1 = "ChatroomHeader-moduleChatroomHeader__tWFP6";
var _2 = "ChatroomHeader-moduleactions__ZHihs";
var _3 = "ChatroomHeader-moduletitle__oOier";
var _4 = "ChatroomHeader-moduletitleFullScreen__WMA4N";
var _5 = "ChatroomHeader-moduletitleSection__gpe2q";
export { _1 as "ChatroomHeader", _2 as "actions", _3 as "title", _4 as "titleFullScreen", _5 as "titleSection" }
